import styled from "styled-components";

export const StudentsWrapper = styled.div`
  .students-header,
  .student-page-card,
  .student-detail-panel,
  .students-empty-state,
  .student-credentials {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    box-shadow: 0 18px 42px rgba(32, 51, 46, 0.06);
  }

  .students-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.5rem;
  }

  .lms-primary-action {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    background: #247467;
    color: #ffffff;
    cursor: pointer;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1;
    padding: 0 1rem;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
  }

  .lms-primary-action:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  .students-header h1,
  .student-page-heading h1,
  .student-detail-panel h1,
  .students-empty-state h1,
  .student-credentials h2,
  .student-card h2 {
    text-transform: none;
    letter-spacing: 0;
    color: #17342f;
  }

  .students-header h1,
  .student-page-heading h1,
  .students-empty-state h1 {
    margin: 0.25rem 0 0.35rem;
    font-size: clamp(1.8rem, 4vw, 3rem);
  }

  .students-header p,
  .student-page-heading p,
  .students-empty-state p,
  .student-detail-panel p {
    margin: 0;
    color: #60716d;
  }

  .students-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }

  .student-card {
    min-height: 148px;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 1rem;
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    padding: 1.25rem;
  }

  .student-avatar {
    width: 52px;
    height: 52px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    background: #e8f3ef;
    color: #1d6257;
    font-size: 1.4rem;
  }

  .student-card h2 {
    margin: 0 0 0.25rem;
    font-size: 1.3rem;
  }

  .student-card p,
  .student-card span {
    margin: 0;
    color: #60716d;
  }

  .student-card-link {
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border-radius: 8px;
    background: #edf4f1;
    color: #1d6257;
    font-weight: 900;
    letter-spacing: 0;
    padding: 0 0.85rem;
  }

  .student-card-actions {
    display: grid;
    gap: 0.45rem;
  }

  .student-card-link.secondary {
    background: #ffffff;
    border: 1px solid #d5dfdc;
    color: #49645e;
  }

  .students-empty-state,
  .student-page-card,
  .student-detail-panel {
    margin-top: 1rem;
    padding: 1.5rem;
  }

  .students-empty-state {
    max-width: 760px;
  }

  .students-empty-state .students-empty-cta {
    margin-top: 1rem;
    min-height: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding-top: 0;
    padding-bottom: 0;
  }

  .student-page-card {
    max-width: 980px;
  }

  .student-form {
    display: grid;
    gap: 1.15rem;
    margin-top: 1.25rem;
    max-width: 780px;
  }

  .student-form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }

  .lms-field {
    min-width: 0;
    display: grid;
    gap: 0.45rem;
    color: #263f3a;
    font-weight: 900;
  }

  .lms-field span {
    font-size: 0.92rem;
    line-height: 1.2;
  }

  .lms-field input,
  .lms-field select {
    width: 100%;
    min-height: 48px;
    border: 1px solid #d4dfdb;
    border-radius: 8px;
    background: #fbfdfc;
    color: #17342f;
    font: inherit;
    font-weight: 700;
    line-height: 1.2;
    padding: 0.75rem 0.85rem;
  }

  .lms-field input:focus,
  .lms-field select:focus {
    border-color: #247467;
    box-shadow: 0 0 0 3px rgba(36, 116, 103, 0.14);
    outline: none;
  }

  .student-form-actions,
  .student-detail-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.25rem;
  }

  .student-secondary-action {
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d5dfdc;
    border-radius: 8px;
    color: #49645e;
    font-weight: 900;
    letter-spacing: 0;
    text-decoration: none;
    padding: 0 1rem;
  }

  .student-credentials {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 1rem;
    background: #f3f9f6;
    margin: 1rem 0;
    padding: 1.25rem;
  }

  .student-credentials h2 {
    margin: 0.25rem 0;
    font-size: 1.35rem;
  }

  .student-credential-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 0.75rem;
  }

  .student-credential-grid article {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    padding: 1rem;
  }

  .student-credential-grid span {
    display: block;
    color: #60716d;
    font-weight: 800;
  }

  .student-credential-grid strong {
    display: block;
    color: #17342f;
    font-size: 1.5rem;
    letter-spacing: 0.04em;
  }

  .student-detail-actions {
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .student-detail-list {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.75rem;
    margin: 1.25rem 0 0;
  }

  .student-detail-list div {
    background: #f6f8f4;
    border-radius: 8px;
    padding: 1rem;
  }

  .student-detail-list dt {
    color: #60716d;
    font-weight: 900;
  }

  .student-detail-list dd {
    margin: 0.25rem 0 0;
    color: #17342f;
    font-weight: 900;
  }

  .student-danger-action {
    min-height: 42px;
    border: 1px solid #f0b8b8;
    border-radius: 8px;
    background: #fff5f5;
    color: #9f2f2f;
    cursor: pointer;
    font-weight: 900;
    margin-top: 1rem;
    padding: 0 1rem;
  }

  .students-error {
    border-radius: 8px;
    background: #fff5f5;
    color: #9f2f2f;
    font-weight: 800;
    margin: 1rem 0 0;
    padding: 0.85rem 1rem;
  }

  .students-loading {
    color: #60716d;
    font-weight: 800;
    margin: 1rem 0;
  }

  @media (max-width: 860px) {
    .students-header,
    .student-credentials,
    .student-detail-list,
    .students-grid {
      grid-template-columns: 1fr;
    }

    .students-header {
      align-items: stretch;
      flex-direction: column;
    }

    .student-card {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .student-card-actions {
      grid-column: 1 / -1;
    }

    .student-card-link {
      justify-content: center;
    }
  }

  @media (max-width: 560px) {
    .student-form-grid,
    .student-credential-grid,
    .student-form-actions,
    .student-detail-actions {
      grid-template-columns: 1fr;
      flex-direction: column;
      align-items: stretch;
    }

    .student-form-actions .lms-primary-action,
    .student-secondary-action,
    .student-detail-actions .lms-primary-action {
      width: 100%;
    }
  }
`;
